import { useMediaQuery } from "react-responsive";

const useDispositivo = () => {
	const esMovil = useMediaQuery({ query: "(max-width: 860px)" });
	const esDesktop = useMediaQuery({ query: "(min-width: 860px)" });
	return { esMovil, esDesktop };
};

export default useDispositivo;
